export default __webpack_public_path__ + "static/media/CRM-7.49167cbe.png";